import React, { useEffect, useState } from 'react'

import { useModal } from '@zet/common/hooks/useModal'
import { Stack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'

import { InputWithLabel } from '../inputWithLabel'

interface SelectDropDownProps {
  label?: string
  placeholder?: string
  onChange: (value: string) => void
  onBlur: () => void
  value?: string
  errorMessage?: string
  dropOptions?: any
  example: string
}

export const SelectDropDown: React.FC<SelectDropDownProps> = ({
  label = 'Select Dropdown',
  placeholder = 'Select',
  onChange,
  onBlur,
  value = '',
  errorMessage,
  dropOptions,
  example,
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(value)
  const { openModal, closeModal } = useModal()

  useEffect(() => {
    if (value) {
      setSelectedValue(value)
    }
  }, [value])

  useEffect(() => {
    return () => closeModal()
  }, [])

  const onSelect = (val: string, displayText: string) => {
    setSelectedValue(displayText)
    onChange(displayText)
    onBlur()
  }

  return (
    <Stack className="mb-3">
      <Pressable
        className="-mb-4"
        onPress={() =>
          openModal('WebFlowSelectorModal', {
            title: i18n.t('webFlow.employmentDetails.type'),
            iconName: 'WorkOutlined',
            criteriaName: 'employmentType',
            options: dropOptions,
            setValue: onSelect,
            selectName: 'value',
          })
        }
      >
        <InputWithLabel
          example={example}
          onChange={() => null}
          isEditable={false}
          placeholder={placeholder}
          onBlur={onBlur}
          iconRight={'ArrowDown'}
          iconLeft={'WorkOutlined'}
          value={value}
          label={label}
          errorMessage={errorMessage}
          pointerEvents="none"
        />
      </Pressable>
    </Stack>
  )
}
